import { createFileRoute } from "@tanstack/react-router";
import { ComingSoonPage } from "@/components/layout/page-container.tsx";

export const Route = createFileRoute("/account")({
  component: () => <ComingSoonPage title="账号管理" />,
});
